import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const state = z
    .union([
    z.literal("AK"),
    z.literal("AL"),
    z.literal("AR"),
    z.literal("AZ"),
    z.literal("CA"),
    z.literal("CO"),
    z.literal("CT"),
    z.literal("DC"),
    z.literal("DE"),
    z.literal("FL"),
    z.literal("GA"),
    z.literal("HI"),
    z.literal("IA"),
    z.literal("ID"),
    z.literal("IL"),
    z.literal("IN"),
    z.literal("KS"),
    z.literal("KY"),
    z.literal("LA"),
    z.literal("MA"),
    z.literal("MD"),
    z.literal("ME"),
    z.literal("MI"),
    z.literal("MN"),
    z.literal("MO"),
    z.literal("MS"),
    z.literal("MT"),
    z.literal("NC"),
    z.literal("ND"),
    z.literal("NE"),
    z.literal("NH"),
    z.literal("NJ"),
    z.literal("NM"),
    z.literal("NV"),
    z.literal("NY"),
    z.literal("OH"),
    z.literal("OK"),
    z.literal("OR"),
    z.literal("PA"),
    z.literal("PR"),
    z.literal("RI"),
    z.literal("SC"),
    z.literal("SD"),
    z.literal("TN"),
    z.literal("TX"),
    z.literal("UT"),
    z.literal("VA"),
    z.literal("VI"),
    z.literal("VT"),
    z.literal("WA"),
    z.literal("WI"),
    z.literal("WV"),
    z.literal("WY"),
])
    .optional()
    .describe(createCustomSettings({
    dependsOn: { field: "Country", value: "United States" },
    label: "State",
}));
export const stateLookup = {
    Alabama: "AL",
    Alaska: "AK",
    Arizona: "AZ",
    Arkansas: "AR",
    California: "CA",
    Colorado: "CO",
    Connecticut: "CT",
    Delaware: "DE",
    "District of Columbia": "DC",
    Florida: "FL",
    Georgia: "GA",
    Hawaii: "HI",
    Idaho: "ID",
    Illinois: "IL",
    Indiana: "IN",
    Iowa: "IA",
    Kansas: "KS",
    Kentucky: "KY",
    Louisiana: "LA",
    Maine: "ME",
    Maryland: "MD",
    Massachusetts: "MA",
    Michigan: "MI",
    Minnesota: "MN",
    Mississippi: "MS",
    Missouri: "MO",
    Montana: "MT",
    Nebraska: "NE",
    Nevada: "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    Ohio: "OH",
    Oklahoma: "OK",
    Oregon: "OR",
    Pennsylvania: "PA",
    "Puerto Rico": "PR",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    Tennessee: "TN",
    Texas: "TX",
    Utah: "UT",
    Vermont: "VT",
    Virginia: "VA",
    "Virgin Islands": "VI",
    Washington: "WA",
    "West Virginia": "WV",
    Wisconsin: "WI",
    Wyoming: "WY",
};
//# sourceMappingURL=states-list.js.map